import {createAction} from 'redux-actions';
import * as ACTION from '../constants';

export const fetchDetailWarehouseStaff = createAction(ACTION.FETCH_DETAIL_WAREHOUSE_STAFF.REQUEST, (id) => ({id}));
export const clearState = createAction(ACTION.CLEAR_STATE);